import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen, Mic } from "lucide-react";
import MonthlyCalendar from "../components/MonthlyCalendar";
import WeeklyProgressChart from "../components/WeeklyProgressChart";
import Chip from "../components/atoms/Chip";
import Button from "../components/atoms/Button";

export default function Calendar() {
  const currentDay = localStorage.getItem("currentDay") || 1;

  return (
    <div className="page-enter" style={{ paddingBottom: 48 }}>
      <Link to="/dashboard" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "var(--fg-3)", fontSize: 13, fontWeight: 500, textDecoration: "none", marginBottom: 12 }}>
        <ArrowLeft size={14} strokeWidth={1.6} /> Dashboard
      </Link>
      <Chip tone="gold">Calendar</Chip>
      <h1 className="font-display" style={{ fontSize: "clamp(40px, 6vw, 56px)", lineHeight: 1.05, fontWeight: 400, letterSpacing: "-0.025em", margin: "12px 0 8px" }}>
        Every day, <em style={{ color: "var(--gold-500)" }}>side by side.</em>
      </h1>
      <p style={{ color: "var(--fg-2)", fontSize: 16, lineHeight: 1.6, maxWidth: "60ch", margin: "0 0 32px" }}>
        A day counts as "perfect" only when both halves are done. The streak counter doesn't care about effort — only about both halves landing.
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
        <WeeklyProgressChart />
        <MonthlyCalendar />

        <div className="grid" style={{ gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <Link to={`/lesson/${currentDay}`} style={{ textDecoration: "none" }}>
            <Button variant="primary" icon={<BookOpen size={16} strokeWidth={1.8} />} style={{ width: "100%", justifyContent: "center" }}>
              Today's written
            </Button>
          </Link>
          <Link to={`/oral/${currentDay}`} style={{ textDecoration: "none" }}>
            <Button variant="speak" icon={<Mic size={16} strokeWidth={1.8} />} style={{ width: "100%", justifyContent: "center" }}>
              Today's oral
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
